import { ACTION_TYPES } from "../actions/doctor";

const initialState = {
    doctors: [],
    metaDoctor: {}
}

export const doctor = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.DOCTOR_FETCH_ALL:
            return {
                ...state,
                doctors: [...action.payload]
            }
        case ACTION_TYPES.DOCTOR_CREATE:
            return {
                ...state,
                doctors: [...state.doctors, action.payload]
            }
        case ACTION_TYPES.DOCTOR_UPDATE:
            return {
                ...state,
                doctors: state.doctors.map(x => x.id === action.payload.id ? action.payload : x)
            }
        case ACTION_TYPES.DOCTOR_DELETE:
            return {
                ...state,
                doctors:state.doctors.filter(x => x.id !== action.payload)
            }
        case ACTION_TYPES.DOCTOR_PAGINATION:
      
            return {
                ...state,
                doctors: [...action.payload.doctors],
                metaCategory: action.payload.meta
            }
        default:
            return state;
    }
}